import { DebugFloatingButton } from './DebugFloatingButton';
import { DebugLayerPanel } from './DebugLayerPanel';
import { useDebugCapability } from './useDebugCapability';

/**
 * Mount-Punkt für den gesamten Debug-Layer.
 *
 * Ist der Nutzer nicht berechtigt, wird gar nichts gerendert — weder
 * Button noch Panel. Das stellt sicher, dass das Panel auch nicht über
 * Provider-State-Tricks im DOM erscheinen kann.
 */
export function DebugLayerHost() {
  const { canUseDebugLayer } = useDebugCapability();
  if (!canUseDebugLayer) return null;
  return (
    <>
      <DebugFloatingButton />
      <DebugLayerPanel />
    </>
  );
}
